const internationalMinutesTableStyle = () => ({
	internationalMinutesTableWrapper: {},
});

export default internationalMinutesTableStyle;
